import { TweenMax } from 'gsap'

export default {
  name: 'link-animation',
  mixins: [],
  data () {
    return {
      needIntersection: true,
      inTransition: false,
      mobile: true
    }
  },
  props: {
    delay: 0,
    block: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.mobile = this.$store.state.ua.platform.type !== 'desktop'
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
    // this.$el._onHover = this.onHover.bind(this)

    // this.$el.addEventListener('mouseover', () => { this.onHover() })
  },
  methods: {
    show () {
      this.$el.classList.remove('up')
      this.$el.classList.remove('down')
    },
    hide (up = true) {
      if (up) {
        this.$el.classList.add('up')
      } else {
        this.$el.classList.add('down')
      }
    },
    mouseenter () {
      this.$el.classList.add('is-hover')
    },
    mouseleave () {
      this.$el.classList.remove('is-hover')
    }
  }
}
